const isMalicious = (maliciousType: string) => {
    const maliciousTypes = ['blacklistable', 'pausable', 'mintable', 'unsellable', 'extremelyMalicious'];
    return maliciousTypes.includes(maliciousType);
}

export default isMalicious;